import React, { useState, useEffect } from 'react';
import NormalButton from './NormalButton';
import { getPageSameType, toTop } from '../../utils/util';
import ReactSVG from 'react-svg';

interface IGotoTopButton {}

const Button = (props: IGotoTopButton) => {
  const [visible, setVisible] = useState(false);

  const checkShowTop = () => {
    if (window.scrollY > window.innerHeight - 100) {
      return true;
    }
    return false;
  };

  // 上来就要检测一下是否应该显示showTop
  useEffect(() => {
    const scrollHandler = () => {
      let result = checkShowTop();
      setVisible(result);
    };

    let result = getPageSameType(window.pageDetail.template, [], 'photo');

    if (result && result.length) {
      setVisible(false);
      window.addEventListener('scroll', scrollHandler);
    }

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return (
    <NormalButton
      className={`${!visible ? 'hide' : ''}`}
      style={{ width: `36px`, height: `36px` }}
      onClick={toTop}
    >
      <ReactSVG
        src={require('../../svg/to-top.svg')}
        style={{
          width: 14,
          height: 19
        }}
      />
    </NormalButton>
  );
};

export default Button;
